import {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/core/store/store.ts";
import getMyProfileRequest from "../../app/core/api/requests/me/getMyProfileRequest.ts";
import getFrontendUtilitiesRequest from "../../app/core/api/requests/utils/getFrontUtilitiesRequest.ts";
import getMyCompaniesRequest from "../../app/core/api/requests/me/getMyCompaniesRequest.ts";
import getNotifications from "../../app/core/api/requests/me/getNotifications.ts";
import {setNotifications} from "../../app/core/store/slices/notificationsSlice.ts";
import loadFilters from "../../app/core/utils/loadFilters.ts";
import {setFilters} from "../../app/core/store/slices/futilsSlice.ts";
import {endLoading, startLoading} from "../../app/core/store/slices/loadingSlice.ts";
import {closeCommandPalette, openCommandPalette} from "../../app/core/store/slices/searcher.ts";
import getPictureOrAvatar from "../../app/core/utils/getPictureOrAvatar.ts";
import {setProfilePicture} from "../../app/core/store/slices/userMeSlice.ts";
import {ModalTalentCommandPalette} from "../../app/modals/ModalTalentCommandPalette.tsx";

const MasterLayout = () => {
  const location = useLocation()
  const userMe = useSelector((state: RootState) => state.userMe)
  const commandPaletteOpen = useSelector((state: RootState) => state.searcher.commandPaletteOpen)

  const dispatch = useDispatch()

  const getMyProfile = async () => await getMyProfileRequest(dispatch);

  const getFrontUtilities = async () => await getFrontendUtilitiesRequest(dispatch);

  const getCompanies = async () => {
    await getMyCompaniesRequest(dispatch)
  }

  const loadNotifications = async () => {
    const response = await getNotifications(dispatch)
    dispatch(setNotifications(response.data))
  }

  const getFilters = async () => {
    const filters = await loadFilters(dispatch);
    dispatch(setFilters(filters))
  }

  const initialRequests = async () => {
    dispatch(startLoading())
    await Promise.all([
      loadNotifications(),
      getCompanies(),
      getFilters(),
      getMyProfile(),
      getFrontUtilities(),
    ])
    dispatch(endLoading())
  }

  useEffect(() => {
    const u = getPictureOrAvatar(
      `${userMe?.user?.name} ${userMe?.user?.lastName}`,
      userMe?.user?.profileImage || '',
      true,
    )

    if (!u) return
    dispatch(setProfilePicture(u))
  }, [userMe.user]);

  useEffect(() => {
    initialRequests()
  }, [])

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const isCmdK = (e.metaKey || e.ctrlKey) && e.key === 'k'
      const isLetterOrNumber = /^[a-zA-Z0-9]$/.test(e.key) && !e.metaKey && !e.ctrlKey && !e.altKey
      if (!isCmdK && !isLetterOrNumber) return

      const tag = document.activeElement?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return

      const hasOtherModalOpen = document.querySelectorAll('.modal.show').length > 0
      if (hasOtherModalOpen) return

      e.preventDefault()
      dispatch(openCommandPalette(isLetterOrNumber ? e.key : undefined))
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [dispatch])

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root vh-100' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <Outlet />
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      <RightToolbar />
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      <ModalTalentCommandPalette
        show={commandPaletteOpen}
        onClose={() => dispatch(closeCommandPalette())}
      />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
